import type { Component } from 'solid-js'
import Button from '~/components/Button'
import Table from '~/components/Table'
import { type LineType, lineSubtotal } from './line'

export interface LineTablePropsType {
  lines: LineType[]
  formatMoney: (value: number) => string
  /** Rótulo de la primera columna (Concepto o Servicio). */
  lineLabel?: string
  /** Header top de la tabla: título y contador a la izquierda, botón Añadir a la derecha. */
  title?: string
  subtitle?: string
  addLabel?: string
  onAdd?: () => void
  onEdit: (index: number) => void
  onDuplicate: (index: number) => void
  onRemove: (index: number) => void
}

/** Líneas en tabla compacta (desktop/tablet), con header y acciones de editar, clonar y quitar. */
const LineTable: Component<LineTablePropsType> = props => {
  return (
    <Table<LineType>
      data={props.lines}
      dense
      keyField="description"
      emptyMessage="Todavía no hay líneas."
      title={props.title}
      subtitle={props.subtitle}
      headerActions={
        props.onAdd ? (
          <Button type="button" size="sm" variant="soft" color="default" onClick={props.onAdd} prependIcon="material-symbols-light:add">
            {props.addLabel ?? 'Añadir'}
          </Button>
        ) : undefined
      }
      columns={[
        { header: props.lineLabel ?? 'Concepto', accessor: (l: LineType) => <span class="font-medium text-foreground truncate">{l.description || '—'}</span> },
        { header: 'Cantidad', accessor: (l: LineType) => <span class="text-foreground-subtle">{l.quantity}</span> },
        { header: 'Precio unitario', accessor: (l: LineType) => <span class="text-foreground-subtle">{props.formatMoney(l.unitPrice)}</span> },
        {
          header: 'Descuento',
          accessor: (l: LineType) =>
            l.discount > 0 ? (
              <span class="text-foreground-subtle">{l.discountType === 'percent' ? `${l.discount}%` : props.formatMoney(l.discount)}</span>
            ) : (
              <span class="text-foreground-subtle">—</span>
            )
        },
        { header: 'Total', accessor: (l: LineType) => <span class="font-semibold text-foreground">{props.formatMoney(lineSubtotal(l))}</span> }
      ]}
      actions={l => (
        <>
          <Button size="sm" variant="text" color="warning" icon="material-symbols-light:edit-outline" tooltip="Editar" onClick={() => props.onEdit(props.lines.indexOf(l))} />
          <Button size="sm" variant="text" color="default" icon="material-symbols-light:content-copy-outline" tooltip="Clonar" onClick={() => props.onDuplicate(props.lines.indexOf(l))} />
          <Button size="sm" variant="text" color="danger" icon="material-symbols-light:delete-outline" tooltip="Quitar" onClick={() => props.onRemove(props.lines.indexOf(l))} />
        </>
      )}
      pagination={false}
      pinnable={false}
    />
  )
}

export default LineTable
